module.exports = __webpack_public_path__ + "img/store-threedcart.7eb50e54.svg";